
export const ACTION_LIST_TYPES_CONTRACTS = "ACTION_LIST_TYPES_CONTRACTS";

export const SHARED_M = "SHARED/";